<template>
  <div class="cropper-upload">
    <el-upload
      ref="ofUpload"
      :limit="limit"
      :accept="accept"
      :headers="headers"
      :action="actionUrl"
      :show-file-list="showFileList"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-error="handleError"
      :on-success="handleSuccess"
      :on-change="handleChange"
      :on-progress="handleProgress"
      :before-upload="handleBefore"
      :list-type="listType"
      :disabled="disabled"
      :file-list="uploadFileList"
      :on-exceed="handleExceed"
      :fixedNumber="fixedNumber"
      :autoCropHeight="autoCropHeight"
      :autoCropWidth="autoCropWidth"
    >
      <slot name="content"></slot>
    </el-upload>
    <el-dialog
      title="图片剪裁"
      :visible.sync="CropperVisible"
      append-to-body
      :fullscreen="true"
    >
      <div class="cropper-content" style="text-align: center">
        <div class="cropper" :style="{ height: cropperheight }">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="option.info"
            :full="option.full"
            :canScale="option.canScale"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed="fixed"
            :fixed-box="fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="autoCropWidth"
            :auto-crop-height="autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
            :info-true="option.infoTrue"
            :max-img-size="option.maxImageSize"
            :enlarge="option.enlarge"
            :mode="option.mode"
            :maxImgSize="option.maxImgSize"
            :fixedNumber="fixedNumber"
          ></vueCropper>
          <div slot="footer" class="dialog-footer footerclass">
            <slot name="footer-operation">
              <el-button @click="CropperVisible = false">取 消</el-button>
              <el-button type="primary" @click="onfinish" :loading="loading"
                >确认</el-button
              >
            </slot>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import appconfig from "@/configs/appConfig.js";
import store from "@/store";
import { VueCropper } from "vue-cropper";

export default {
  name: "of-upload",
  components: {
    VueCropper,
  },
  props: {
    action: {
      type: String,
      default: "/api/File/FileUpload",
    },
    headers: {
      type: Object,
      default() {
        return {
          "OF-Authorization": store.getters.GetUserToken,
        };
      },
    },
    limit: {
      type: Number,
      default: 1,
    },
    accept: {
      type: String,
      default: "*",
    },
    listType: {
      type: String,
      default: "text",
    },
    fileList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    showFileList: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    IsVideo: {
      type: Boolean,
      default: false,
    },
    //截图
    img: {
      type: String,
      default: "",
    },
    info: {
      type: Boolean,
      default: true,
    },
    outputSize: {
      type: Number,
      default: 1,
    },
    outputType: {
      type: String,
      default: "jpeg",
    },
    canScale: {
      type: Boolean,
      default: true,
    },
    autoCrop: {
      type: Boolean,
      default: true,
    },
    autoCropWidth: {
      type: Number,
      default: 1,
    },
    autoCropHeight: {
      type: Number,
      default: 1,
    },
    fixedBox: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    fixedNumber: {
      type: Array,
      default: function () {
        return [1, 1];
      },
    },
    full: {
      type: Boolean,
      default: true,
    },
    canMoveBox: {
      type: Boolean,
      default: true,
    },
    original: {
      type: Boolean,
      default: true,
    },
    centerBox: {
      type: Boolean,
      default: false,
    },
    infoTrue: {
      type: Boolean,
      default: true,
    },
    canMove: {
      type: Boolean,
      default: true,
    },
    resizeTimeOut: {
      type: Number,
      default: 20,
    },
  },
  computed: {
    actionUrl() {
      return appconfig.ApiPrefix + this.action;
    },
  },
  data() {
    return {
      option: {
        img: [], // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "png", // 裁剪生成图片的格式
        full: true, // 是否输出原图比例的截图
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 150, // 默认生成截图框高度
        canMove: true, // 上传图片是否可以移动
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        canMoveBox: true, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        height: true,
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: "contain", // 图片默认渲染方式
        maxImgSize: 2000, // 限制图片最大宽度和高度
      },
      uploadFileList: [],
      CropperVisible: false,
      loading: false,
      befimg: [],
      sucfilearr: [],
      cropperheight: "100px",
    };
  },
  watch: {
    fileList: function (newVal,oldVal) {
      let vm = this;
      if(newVal){
        vm.uploadFileList = vm.fileList
        vm.sucfilearr = vm.uploadFileList 
      }
    },
  },
  mounted() {
    let vm = this;
    vm.uploadFileList = vm.fileList;
    vm.sucfilearr = vm.uploadFileList
  },
  methods: {
    handleRemove(file) {
      let vm = this;
      for(var i = 0;i < vm.uploadFileList.length;i++){
        if(vm.uploadFileList[i].uid == file.uid){
          vm.uploadFileList.splice(i, 1);
        }
      }
      this.$emit("onRemove", file, vm.uploadFileList);
    },
    handlePreview(file) {
      this.$emit("onPreview", file);
    },
    handleSuccess(res, file) {
      let vm = this
      vm.uploadFileList
      this.$emit("onUpLoad", file, res, vm.uploadFileList);
    },
    handleError(file) {
      this.$emit("onError", file);
    },
    handleBefore(file) {
      let vm = this
      let uploadStatus = true;
      this.$emit("onCheckFile", file, function (status) {
        uploadStatus = status;
      });
      if (uploadStatus == true) {
        if(file.type.indexOf("image") > -1 && vm.autoCropWidth > 1){
          this.onCropper(file, function (status) {
            uploadStatus = status;
          });
        }
      }
      return uploadStatus;
    },
    onCropper(file, status) {
      this.CropperVisible = true;
      this.setContentHeight();
      status(false);
      return;
    },
    onfinish(file) {
      this.loading = true;
      this.CropperVisible = false;
      var _that = this;
      this.$refs.cropper.getCropBlob((data) => {
        var xhr, formData;
        let file = new window.File([data], _that.befimg.name, {
          type: data.type,
        });
        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open("POST", "/api/File/FileUpload");
        xhr.onload = function () {
          let json;
          if (xhr.status != 200) {
            failFun("HTTP Error: " + xhr.status);
            return;
          }
          json = JSON.parse(xhr.response);
          if (!json) {
            failFun("Invalid JSON: " + xhr.responseText);
            return;
          }
          var sucfile = {
            name: file.name,
            percentage: 100,
            raw: file,
            size: file.size,
            response: json,
            status: "success",
            uid: file.lastModified,
            url: json.Data.DownloadUrl,
          };
          _that.sucfilearr.push(sucfile);
          _that.handleSuccess(sucfile, json);
          _that.handleChange(sucfile, _that.sucfilearr);
        };
        formData = new FormData();
        formData.append("file", file, file.name); //此处与源文档不一样
        xhr.send(formData);
      });
      this.loading = false;
    },
    handleChange(file, fileList) {
      let vm = this;
      vm.befimg = file;
      vm.uploadFileList = fileList;
      vm.option.img = file.url;
      this.$emit("onChange", file, vm.uploadFileList);
    },
    handleProgress(event, file, fileList) {
      this.$emit("onProgress", event);
    },
    handleExceed(file, fileList) {
      this.$emit("onExceed", file);
    },
    setContentHeight() {
      var height = window.innerHeight - 130;
      this.cropperheight = `${height}px`;
    },
  },
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px !important;
  height: 178px !important;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px !important;
  height: 178px !important;
  display: block;
}

.cropper-content .avatar-uploader {
  background: red !important;
  width: 150px;
  height: 150px;
  text-align: center;
  line-height: 150px;
}
.cropper-content .el-icon-plus {
  width: 150px;
  height: 150px;
  font-size: 30px;
}
.cropper-content {
  width: 100%;
  height: 400px;
  background: pink;
}
.cropper-content .cropper {
  width: 100%;
  height: 400px;
  background: yellow;
}
.footerclass {
  padding: 10px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
